// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"ErpAgentsCard_innerContainer__2Zz28","erpAgentsInfo":"ErpAgentsCard_erpAgentsInfo__2dhIx","title":"ErpAgentsCard_title__3xvDZ","data":"ErpAgentsCard_data__3QxXI"};